<template>
    <v-dialog v-model="dialogExcelEditor" persistent :max-width="editor_width">
        <v-card>
            <v-card-title>
                <span class="title">{{ title }}</span>
                <v-spacer></v-spacer>
                <v-btn color="red" class="mx-2" icon rounded outlined small @click="closePopup"><v-icon dark>fa-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-icon medium class="ma-2" color="gray darken-3" @click="insertRow">fa-plus-square</v-icon>
                        <v-icon medium class="ma-2" color="gray darken-3" @click="deleteRow">fa-trash-alt</v-icon>
                        <v-icon medium class="ma-2" color="gray darken-3" @click="exportRow">fa-download</v-icon>
                        <v-icon medium class="ma-2" color="gray darken-3" @click="importRow">fa-upload</v-icon>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                        <vue-excel-editor ref="excel_editor" v-model="jsonData" :no-paging="true" :new-if-bottom="true"
                            @update="onUpdateAuthAccount" @delete="onDeleteAuthAccount">
                            <template v-for="(item, index) in columns">
                                <vue-excel-column v-if="item && item !== undefined" :field="item.name"
                                    :width="item.width ? item.width : '100px'" :label="item.label"
                                    :key-field="item.key_field" :type="item.type ? item.type : 'string'"
                                    :options="item.options" :key="index" />
                            </template>
                        </vue-excel-editor>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
    name: "oee-excel-editor",
    data() {
        return {
            dialogExcelEditor: false,
            jsonData: null
        };
    },
    props: ["dialog", "title", "editor_width", "columns", "value"],
    watch: {
        value() {
            this.jsonData = this.value ? JSON.parse(this.value) : [];
        },
        dialog() {
            this.dialogExcelEditor = this.dialog;
            this.jsonData = this.value ? JSON.parse(this.value) : [];
        }
    },
    methods: {
        closePopup() {
            this.dialogExcelEditor = false;
            this.$emit("closePopup");
        },
        deleteRow() {
            this.$refs.excel_editor.deleteSelectedRecords()
        },
        insertRow() {
            this.$refs.excel_editor.newRecord()
        },
        exportRow() {
            const format = 'xlsx'
            const exportSelectedOnly = true
            const filename = 'excel_editor'
            this.$refs.excel_editor.exportTable(format, exportSelectedOnly, filename)
        },
        importRow() {
            this.$refs.excel_editor.importTable();
        },
        onUpdateAuthAccount(records) {
            for (let index = 0; index < this.jsonData.length; index++) {
                const element = this.jsonData[index];
                for (const [key, value] of Object.entries(element)) {
                    if (key == 'active' || key == 'value' || key == 'wallet' || key == 'value_from' || key == 'value_to' || key == 'ex_fee' || key == 'rate' || key == 'free' || key == 'default') {
                        element[key] = Number(value);
                    }
                }
            }

            let value = JSON.stringify(this.jsonData);
            this.$emit("change", value);
        },
        onDeleteAuthAccount(records) {
            for (let index = 0; index < this.jsonData.length; index++) {
                const element = this.jsonData[index];
                for (const [key, value] of Object.entries(element)) {
                    if (key == 'active' || key == 'value' || key == 'wallet' || key == 'value_from' || key == 'value_to' || key == 'ex_fee' || key == 'rate' || key == 'free' || key == 'default') {
                        element[key] = Number(value);
                    }
                }
            }
            let value = JSON.stringify(this.jsonData);
            this.$emit("change", value);
        }
    }
};
</script>